import { defineStore } from 'pinia';

export const useShareAuthorStore = defineStore('', {
    id: 'projShareAuthorStore',
    state: () => ({
        author: {
            shareId: '',
            shareUserId: '',
            shareUsername: '',
            shareOrgId: '',
            username: '',
            accessToken: '',
        },
        project: { id: '', name: '' },
    }),
    getters: {
        accessToken (state) {
            const { accessToken = '' } = state.author || {};
            return accessToken;
        },
        isAuthenticated (state) {
            const { accessToken = '' } = state.author || {};
            return accessToken !== '';
        },
        projectId (state) {
            const { id = '' } = state.project || {};
            return id || '';
        },
    },
    actions: {
        'setProject' (project) {
            this.$patch(state => {
                state.project = { ...state.project, ...project };
            });
        },
        'setAuthor' ({
            shareId,
            shareUserId,
            shareOrgId,
            shareUsername,
            username,
            projectId,
            accessToken,
        }) {
            this.$patch((state) => {
                Object.assign(state.author, {
                    shareId,
                    shareUserId,
                    shareUsername,
                    shareOrgId,
                    username,
                    accessToken,
                });
                state.project.id = projectId;
            });
        },
        'clear' () {
            this.$patch(state => {
                state.accessToken = '';
                state.projectId = '';
                state.project = { id: '', name: '' };
                Object.assign(state.author, {
                    shareId: '',
                    shareUserId: '',
                    shareUsername: '',
                    shareOrgId: '',
                    username: '',
                });
            });
        },
    },
    persist: {
        key: 'jxpj-projShareAuthorStore',
        storage: sessionStorage,
    },
});
